import React from 'react';

export const Button = ({ classProp, clickFuncProp, isDisableProp, contentProp }) => {
  return (
    <button className={`w-full py-3 ${classProp}`} onClick={clickFuncProp} disabled={isDisableProp}>
      {contentProp}
    </button>
  );
};
